__turbopack_context__.v({
  "blok-big-title": "apris_a96bd255-module__TxbH8G__blok-big-title",
  "blok-subtitle": "apris_a96bd255-module__TxbH8G__blok-subtitle",
  "blok-title": "apris_a96bd255-module__TxbH8G__blok-title",
  "className": "apris_a96bd255-module__TxbH8G__className",
  "variable": "apris_a96bd255-module__TxbH8G__variable",
});
